// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../style/colors.css\"","font":"\"../style/font.css\"","dark":"#111111","white":"#fff","light":"#92acad","FONT_FAMILY":"'Varela Round', sans-serif"};